/*
  Purito – hediye BB Krem seçimi (hızlı sepet)
  - "Rengini seç" butonu paneli açar/kapatır
  - Renk kartına tıklanınca ürün sepete eklenir ve tema kendi sepet yenileme olayıyla
    (theme:cart:<view>:updateHtml) hızlı sepeti günceller.
  Tıklamalar document üzerinden dinlenir; tema sepet içeriğini değiştirse de çalışmaya devam eder.
*/
(function () {
  if (window.__puritoGiftInit) return;
  window.__puritoGiftInit = true;

  var routes = (window.Shopify && window.Shopify.routes) || {};
  var root = routes.root || '/';
  var cartPath = routes.cart || root + 'cart';

  function cartSections() {
    // Tema ile aynı mantık: sepet sayfasında 3 bölüm, diğer sayfalarda yalnızca hızlı sepet
    return window.location.pathname === cartPath
      ? ['cart-drawer', 'cart-desktop', 'cart-mobile']
      : ['cart-drawer'];
  }

  function emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function showError(block, text) {
    var el = block && block.querySelector('.purito-gift__error');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  }

  async function addGift(button) {
    var block = button.closest('.purito-gift');
    var variantId = parseInt(button.getAttribute('data-gift-variant'), 10);
    if (!variantId) return;

    block.querySelectorAll('.purito-gift__option').forEach(function (b) {
      b.setAttribute('disabled', 'disabled');
    });
    button.setAttribute('aria-busy', 'true');

    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _kampanya: 'Hediye BB Krem' } }],
          sections: cartSections()
        })
      });

      var data = await res.json();

      if (!res.ok) {
        throw new Error(data && (data.description || data.message) ? (data.description || data.message) : 'add_failed');
      }

      // Sepet sayacını güncelle
      try {
        var cartRes = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        var cart = await cartRes.json();
        var counter = document.querySelector('[data-cart-count]');
        if (counter) counter.setAttribute('data-cart-count', cart.item_count);
        var viewport = document.querySelector('.layout--viewport');
        if (viewport) viewport.setAttribute('data-cart-empty', cart.item_count === 0);
      } catch (e) {}

      // Temanın kendi sepet yenileme mekanizmasını tetikle
      var sections = data.sections || {};
      var keys = Object.keys(sections);
      if (!keys.length) {
        window.location.reload();
        return;
      }
      keys.forEach(function (id) {
        if (!sections[id]) return;
        emit('theme:cart:' + id.replace(/^cart-/, '') + ':updateHtml', {
          section: sections[id],
          load_transitions: false
        });
      });
      emit('theme:cart:productAdded', variantId);
    } catch (err) {
      button.removeAttribute('aria-busy');
      block.querySelectorAll('.purito-gift__option').forEach(function (b) {
        if (!b.hasAttribute('aria-disabled')) b.removeAttribute('disabled');
      });
      showError(
        block,
        err && err.message && err.message !== 'add_failed'
          ? err.message
          : 'Hediye eklenemedi, lütfen tekrar deneyin.'
      );
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-gift-toggle]');
    if (toggle) {
      event.preventDefault();
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open && panel.scrollIntoView) {
        requestAnimationFrame(function () {
          panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }
      return;
    }

    var option = event.target.closest('[data-gift-variant]');
    if (option && !option.disabled) {
      event.preventDefault();
      addGift(option);
    }
  });
})();
